export default {
    url: '/view/:id',
    template: `
        <evaluation-view
            evaluation-group="vm.evaluationGroup"
            comparison-groups="vm.comparisonGroups"
            sites="vm.sites"
            classifiers="vm.classifiers"
            forms="vm.forms"
            company="vm.company"
        />`,
    resolve: {
        evaluationGroup ($stateParams, EvaluationGroupResource) {
            return EvaluationGroupResource.get({
                id: $stateParams.id,
                expand: 'form,completedEvaluationCount,notCompletedEvaluationCount,activeI18n,evaluationGroupI18ns'
            }).$promise;
        },
        sites ($stateParams, SiteResource) {
            return SiteResource.query({ evaluationGroupId: $stateParams.id, pageSize: 0 }).$promise;
        },
        forms ($stateParams, FormResource, FORMS_TYPE_ENUM) {
            return FormResource.query({ pageSize: 0, type: FORMS_TYPE_ENUM.KEYS.FORM_360_FEEDBACK }).$promise;
        },
        comparisonGroups ($stateParams, EvaluationGroupResource, evaluationGroup) {
            return EvaluationGroupResource.query({ comparisonId: evaluationGroup.id }).$promise;
        },
        classifiers: (ClassifierResource) => ClassifierResource.query({ pageSize: 0 }).$promise,
        company (CompanyResource, TokenService) {
            return CompanyResource.publicView({ id: TokenService.getCompanyId(), expand: 'companyI18ns' }).$promise;
        }
    },
    controller (evaluationGroup, sites, forms, comparisonGroups, classifiers, company) {
        this.evaluationGroup = evaluationGroup;
        this.comparisonGroups = comparisonGroups;
        this.classifiers = classifiers;
        this.sites = sites;
        this.forms = forms;
        this.company = company;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/evaluation/view/index.js